module.exports = __webpack_public_path__ + "static/img/icon-cross-publisher.67afc4d1.svg";